// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1pXWR","label":"Category_label__1vxMm","content":"Category_content__31hcf","header":"Category_header__3S3xC","location":"Category_location__3ivjc"};